'use strict';

const Manager = require('./Manager');
const Driver = require('./ManagerDrivers/Driver');
const PairSession = require('./ManagerDrivers/PairSession');

/**
 * @class
 * @hideconstructor
 * @extends HomeyAPIV3.Manager
 * @memberof HomeyAPIV3
 */
class ManagerDrivers extends Manager {

  static CRUD = {
    ...super.CRUD,
    Driver,
    PairSession,
  }

}

module.exports = ManagerDrivers;
